<template>
  <div class="share">
    <div v-show="!isCopied" class="abs cont before">
      <img src="@images/shareBeforeTip.png" alt="">
      <img src="@images/shareBeforeBtn.png" alt="" class="shareBeforeBtn" @click="shareBeforeBtn" :data-clipboard-text="shareURL">
      <img src="@images/copyTip.png" alt="">
    </div>
    <div v-show="isCopied" class="abs cont after">
      <img src="@images/shareAfterTip.png" alt="">
      <img src="@images/shareAfterBtn.png" alt="" class="shareAfterBtn" @click="shareAfterBtn">
    </div>
  </div>
</template>

<script>
import { closePop, updateInitUser } from '@/utils/common.js';
import { share } from '@/network/api';
import { mapState } from 'vuex'

export default {
  data(){
    return {
      isCopied: false,
    }
  },
  computed: {
    ...mapState([ 'currentPop', 'shareURL' ]),
  },
  watch: {
    currentPop(newValue){
      if(newValue === 'Share'){
        this.isCopied = false;
      }
    }
  },
  mounted(){
    this.initClipboard();
  },
  methods: {
    closePop,
    updateInitUser,
    initClipboard(){
      const clipboard = new ClipboardJS('.shareBeforeBtn');
      clipboard.on('success', () => {
        alert("已经复制到粘贴板");
      });
      clipboard.on('error', function(e) {
        alert("复制失败");
      });
    },
    shareBeforeBtn(){
      share().then(res => {
        if(res.status === 1){
          this.updateInitUser();
          this.isCopied = true;
        }else{
          alert(res.message)
        }
      })  
    },
    shareAfterBtn(){
      this.closePop();
    }
  }
}
</script>

<style scoped>
.share{ width: 681px; height: 436px; background: url(@images/share.png) no-repeat 0 0;}
.cont{ top: 68px; left: 48px; width: 601px; height: 343px; display: flex; flex-wrap: wrap; justify-content: center; align-content: center;}
.shareBeforeBtn{ margin: 25px 0;}
.shareAfterBtn{ margin-top: 45px;}
</style>